import React from 'react'
import { workingdaysOptions } from '../../assests/extention/commonfunction';

export default function WorkingDayComponent({ formData }) {
    const workingDaysStr = formData?.preferences?.working_days || ""; // "1,4,2,3,5"
    const workingDaysArray = workingDaysStr.split(",").map((id) => parseInt(id, 10));

    // Map IDs to names
    const dayNames = workingDaysArray
        .map((id) => workingdaysOptions.find((d) => d.id == id)?.day?.slice(0, 3)) // get short form
        .filter(Boolean) // remove undefined
        .join(", ");

    return (
        <p>{dayNames}</p>
    )
}
